import { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Dark, Minimal, Orange, Strong } from '../styled-components'
import { ChipsContext } from './chips-context'
import {
  chipsVariantOptions,
  chipsSizeOptions,
  chipsComponentTypeOptions
} from '../constants'

export const chipVariantComponentOptions = {
  [chipsVariantOptions.MINIMAL]: Minimal,
  [chipsVariantOptions.STRONG]: Strong,
  [chipsVariantOptions.DARK]: Dark,
  [chipsVariantOptions.ORANGE]: Orange
}

const ChipsRoot = forwardRef(
  (
    {
      children,
      variant,
      componentType = chipsComponentTypeOptions.CHOICE,
      size = chipsSizeOptions.MEDIUM,
      disabled = false,
      fullWidth = false,
      onClick: customClick,
      rightIcon,
      isSelected: isSelectedProp = false,
      setIsSelected: setIsSelectedProp,
      ...props
    },
    forwardedRef
  ) => {
    const [selected, setSelected] = useState(false)

    const isSelected = isSelectedProp ?? selected
    const setIsSelected = setIsSelectedProp ?? setSelected

    const Component = chipVariantComponentOptions[variant] || Minimal

    const handleClickRoot = () => {
      customClick && customClick()
      setIsSelected(!isSelected)
    }

    return (
      <ChipsContext.Provider
        value={{
          componentType,
          variant,
          size,
          disabled,
          fullWidth,
          isSelected
        }}
      >
        <Component
          ref={forwardedRef}
          disabled={disabled}
          size={size}
          componentType={componentType}
          fullWidth={fullWidth}
          onClick={handleClickRoot}
          aria-selected={isSelected}
          selected={isSelected}
          {...props}
        >
          {children}
        </Component>
      </ChipsContext.Provider>
    )
  }
)

ChipsRoot.displayName = 'ChipsRoot'

ChipsRoot.propTypes = {
  children: PropTypes.any,
  componentType: PropTypes.oneOf(Object.values(chipsComponentTypeOptions)),
  variant: PropTypes.oneOf(Object.keys(chipsVariantOptions)),
  size: PropTypes.oneOf(Object.values(chipsSizeOptions)),
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

export default ChipsRoot
